import { For, onMount } from "solid-js";
import { trackBeacon } from "~/lib/analytics";
import {
  CLAIM_STEPS_OTHERS,
  CLAIM_STEPS_SELF,
  HELP_FAQS,
  HELP_SUPPORT_EMAIL,
} from "~/lib/help-content";

export function HelpPage() {
  onMount(() => {
    trackBeacon("help_opened", undefined, { page: "/help" });
  });

  return (
    <section class="card help-page">
      <p class="status-chip">Help</p>
      <h1>Connect FAQ and ticket claim</h1>
      <p class="muted">
        Connect is the opt-in directory for DataEngBytes ticket holders. This page is public — you
        do not need to be signed in to read it.
      </p>

      <nav class="help-toc" aria-label="On this page">
        <a href="#claim">Claim your ticket</a>
        <a href="#someone-else">Bought for someone else</a>
        <a href="#faq">FAQ</a>
      </nav>

      <h2 id="claim">How to claim your ticket</h2>
      <p>
        There is no claim code in the email. Connect matches the email you sign in with to the
        email on the ticket.
      </p>
      <ol class="help-steps">
        <For each={CLAIM_STEPS_SELF}>{(step) => <li>{step}</li>}</For>
      </ol>
      <p>
        <a href="/login">Sign in to Connect</a>
        {" · "}
        <a href="/tickets">Manage tickets</a>
      </p>

      <h2 id="someone-else">Bought seats for other people</h2>
      <ol class="help-steps">
        <For each={CLAIM_STEPS_OTHERS}>{(step) => <li>{step}</li>}</For>
      </ol>

      <h2 id="faq">FAQ</h2>
      <div class="help-faq">
        <For each={HELP_FAQS}>
          {(item) => (
            <details id={item.id} class="help-faq-item">
              <summary>{item.question}</summary>
              <For each={item.answer}>{(para) => <p>{para}</p>}</For>
            </details>
          )}
        </For>
      </div>

      <div class="support-box">
        <h2>Still stuck?</h2>
        <p>
          Email{" "}
          <a href={`mailto:${HELP_SUPPORT_EMAIL}`}>{HELP_SUPPORT_EMAIL}</a> and include the email
          you signed in with, the email on the ticket, and which city.
        </p>
      </div>
    </section>
  );
}
